<template>
  <router-view :style="[getPrimaryColor]" />
  <transition-group name="showMenu">
    <QuickView v-if="$store.getters.modalIsQuickView" v-bind="getCurrentQuickViewProduct" />
    <!-- <Modal v-if="$store.state.app.currentActiveModal === 'newsletter'" /> -->
  </transition-group>

  <div class="modal-background" v-if="$store.state.app.currentActiveModal !== ''"
    @click="$store.commit('forceCloseModal')"></div>
  <div class="websocket-status-indicator" :class="{ connected: isWebSocketConnected }" :title="statusText">
    <span class="dot"></span>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import colors from "./views/color_schemes.json";
import QuickView from "./components/molecules/Modal/QuickView.vue"
import Modal from "./components/molecules/Modal/NewsLetterPopup.vue"
import auctionsData from "./data/auctions.json";
const { products } = auctionsData;
export default {
  components: { QuickView, Modal },
  created() {
    document.addEventListener('keydown', e => {
      let key = e.key;
      if (key && 'Escape' === key) {
        this.$store.commit('forceCloseModal')
      }
    }, false);

    // if (document.cookie.indexOf('modal=true') === -1) {
    //   setTimeout(function () {
    //     this.$store.commit('toggleModal', 'newsletter');
    //   }.bind(this), 3000)
    // }

  },
  watch: {
    "$store.state.app.currentActiveModal": function () {
      let body = document.getElementsByTagName("BODY")[0];
      let modalsState = this.$store.state.app.currentActiveModal;
      if (modalsState !== "") {
        body.style.overflow = "hidden";
      } else {
        body.style.overflow = "auto";
      }
    },
  },
  data() {
    return {
      colors,
    };
  },
  computed: {
    ...mapState('websocket', {  // 添加 WebSocket 状态
      wsError: state => state.error,
      wsReconnecting: state => state.connection.reconnecting
    }),

    ...mapGetters('websocket', [  // 添加 WebSocket getters
      'isConnected',
      'statusText',
      'reconnectAttempts'
    ]),

    // 为了模板中使用的计算属性
    isWebSocketConnected() {
      return this.isConnected;
    },

    websocketStatusText() {
      if (this.isConnected) return 'WebSocket 已连接';
      if (this.wsReconnecting) return `WebSocket 重连中 (${this.reconnectAttempts}/10)`;
      if (this.wsError) return `WebSocket 错误: ${this.wsError}`;
      return 'WebSocket 未连接';
    },
    getCurrentColor() {
      // console.log(process.env.VUE_APP_PRIMARY_COLOR === ""
      //   ? colors[process.env.VUE_APP_CURRENT_THEME]
      //   : process.env.VUE_APP_PRIMARY_COLOR, '3333333')
      return process.env.VUE_APP_PRIMARY_COLOR === ""
        ? colors[process.env.VUE_APP_CURRENT_THEME]
        : process.env.VUE_APP_PRIMARY_COLOR;
    },
    getPrimaryColor() {
      return (
        "--primary-color:" +
        this.getCurrentColor +
        ";" +
        "--swiper-theme-color: " +
        this.getCurrentColor +
        ";" + "--primary-block-color:" +
        this.colors.primaryBlock +
        ";" + "--primary-block-text-color:" +
        this.colors.primaryBlockText +
        ";"
      );
    },
    getCurrentQuickViewProduct() {
      return products.find((prod) => {
        return prod.id == this.$store.state.app.currentActiveModal.split('-')[1]
      })
    }
  },
  mounted() {
    // 在组件挂载后连接 WebSocket
    this.initWebSocket();
  },
  methods: {
    async initWebSocket() {
      try {
        this.$store.dispatch('websocket/connectWithTicket', {
          url: process.env.VUE_APP_WS_TARGET || 'ws://localhost:8080'
        }).catch(error => {
          console.log('WebSocket 连接将在后台重试');
        });
      } catch (error) {
        console.error('WebSocket 连接失败:', error);
        // 连接失败不阻塞应用，让重连机制处理
      }
    },
  }
};
</script>
<style src="./assets/main.css"></style>
<style scoped>
.websocket-status-indicator {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #f56c6c;
  box-shadow: 0 0 5px rgba(245, 108, 108, 0.5);
  z-index: 9999;
  cursor: pointer;
  transition: all 0.3s ease;
}

.websocket-status-indicator.connected {
  background-color: #67c23a;
  box-shadow: 0 0 5px rgba(103, 194, 58, 0.5);
  animation: pulse 2s infinite;
}

.websocket-status-indicator:hover::after {
  content: attr(title);
  position: absolute;
  bottom: 20px;
  right: 0;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  pointer-events: none;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(103, 194, 58, 0.7);
  }

  70% {
    box-shadow: 0 0 0 6px rgba(103, 194, 58, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(103, 194, 58, 0);
  }
}
</style>